import React from 'react';
import {Movies} from "../components/MovieComponent/Movies";

const MoviesPage = () => {

    return (


        <div>
            <Movies/>
        </div>
    );
};

export {MoviesPage};